import { PrimaryButton } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useDemoProfile } from '../../../modulesTemp/shared/useDemoProfile'
import {
	EskatDummyTextStyle,
	StyledRegularButtonWrapper,
} from '../Eskat.styled'
import { EskatApiEnvironment } from '../Eskat.types'

interface EskatDummyDataConsentProps {
	environment: string
	clientId: number | null
	handlePostTestDataClick: () => void
}

const DummyContinueWrapper = styled.div`
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
`

export const EskatDummyDataConsent = ({
	clientId,
	handlePostTestDataClick,
	environment,
}: EskatDummyDataConsentProps) => {
	const { t } = useTranslation()
	const demoProfile = useDemoProfile()

	const isProduction = environment === EskatApiEnvironment.Production
	const showDummyDataConsent =
		(!isProduction || isAllowedPlaywrightClient(isProduction, clientId)) &&
		demoProfile === null

	if (!showDummyDataConsent) {
		return null
	}

	return (
		<DummyContinueWrapper>
			<StyledRegularButtonWrapper>
				<PrimaryButton onClick={handlePostTestDataClick}>
					{t('consent-dummyData-link')}
				</PrimaryButton>
			</StyledRegularButtonWrapper>
			<EskatDummyTextStyle>
				{t('consent-dummyData-linkNoteTxt')}
			</EskatDummyTextStyle>
		</DummyContinueWrapper>
	)
}

const playwrightClientId = 180

const isAllowedPlaywrightClient = (
	isProduction: boolean,
	clientId: number | null,
) => {
	// This is enforced also in backend
	return isProduction && clientId === playwrightClientId
}
